var _path, _path2, _path3, _linearGradient, _linearGradient2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaKentuckyKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.59 33.8c-.24 1.41-1.69 2.55-3.46 2.67-3.35.24-6.78-.99-6.97-5.65-.14-3.38 0-17.81 0-17.81.35-4.7 8.59-6.47 11.02-1.03 1.31-1.96 5.2-3.61 6.68-1.74 2.02-.17 14.95-1.52 15.8-.32 2.49-.36 7.18-1.19 9.12.82 0 0 1.2-2.1 4.31-1.67 2.27.31 5.82.72 6.01 3.7 8.81-7.45 20.78-1.67 20.8 9.86.01 11.4-11.67 18.14-20.68 11.2l-.49.04s-.81 1.92-2.83 2.24c-2.08.33-7.19 1.42-8.45-.89-1.08 2.12-7.99 1.04-7.99.46-5.3-.26-10.08 3.38-14.91-1.07-3.12 2.48-5.43 1.93-7.96-.81zm6.43-11.31L32 23.57l-.56-.53c-.01 0 .43-.7.58-.55zm44.45-2.14s.48.69.42 3.2c-.05 2.5-.35 2.68-.62 2.59-.26-.08-.97-3.26.2-5.79z",
    fill: "#fbc34f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.86 31.29s3.5 3.91 4.77 3.84 3.78-2.06 4.07-2.06c.28 0 .49.25.95.71s2.86 1.85 3.57 1.88c.71.04 2.33-.1 5.83-.75l4.38-.6s.14.32 1.06.59 4.06.67 5.23.28 1.55-2.58 1.55-2.58.44 1.53 1.13 2.08 1.67.77 3.21.77 4.68-.21 5.71-1.42.78-2.7.78-2.7 1.4 2.01 4.74 3.32 6.86.6 7.51.44c.66-.16 7.76-2.38 8.15-12.19s-7.28-12.34-9.58-12.37c-2.3-.04-5.16.43-7.31 1.85s-2.86 2.95-3.22 3.2c-.35.25-.3-.6-.26-1.67s-.28-2.51-1.73-3.02c-1.45-.52-3.87-.58-5-.44s-2.19 1.3-2.21 2.13c-.02.84-.06 1.28-.02 1.56.04.29-.23.23-.51-.98s-1.41-2.37-2.42-2.47c-1.01-.11-4.12.16-5.09.32s-1.22.34-1.22.34-.6-.69-2.54-.68c-1.94.02-10.69.46-11.63.5-.93.04-1.47.37-1.47.37s-2.21-1.15-3.3-.9c-1.1.25-1.75.75-2.84 1.99l-1.94 2.19s.24-2.35-.21-3.04c-.46-.69-1.11-1.42-2.54-1.39-1.43.04-4.1.43-5 .67-.9.25-1.43 1.05-1.34 6.01l.48 15.02c.14 1.17 1.06 2.42 2.4 2.88 1.35.46 3.79.28 4.59-.11.79-.39 1.25-1 1.31-1.92.02-.92-.04-1.65-.04-1.65zm5.12-8.08 3.3-4.66-.09 7.84-.34-.02-2.87-3.16zm17.16-3.78-1.19.01s-.2.21.21.2c.4-.01.62.06.73.36.1.3.24.21.24.21l.01-.78zm29.61-1.34s1.48 1.79 1.41 5.21c-.07 3.41-1.43 4.55-1.7 4.55-.26 0-2.05-1.42-1.94-4.59.11-3.16 2.23-5.17 2.23-5.17z",
    style: {
      fill: "#262424"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 19.02s6.21-7.22 6.78-7.5c.56-.28 1.18-.25 2.14.32.95.57 1.89.98 1.71 1.35s-6.39 9.05-6.39 9.05 6.56 6.65 6.56 6.9-3.31 2.47-3.73 2.68-.87-.07-1.4-.53-5.92-6.08-5.92-6.08.01 5.84-.16 6.22-.49.66-1.38.64c-.88-.02-2.65-.16-3.09-1.46s-.48-16.12-.44-17.19 1.03-1.69 2.86-2.01c1.84-.32 2.48-.55 2.48 1.05l-.02 6.56zm16.92-2.9 8.34-.04c.42-.07.62-.64.42-2.24-.19-1.6-.78-2.33-.97-2.37-.2-.04-12.79.43-13.29.5s-.5.91-.32 1.83 1.13 2.49 1.13 2.49l.06 14.06c.12.32 2.65 2.04 3 2.06.36.02 5.16-.69 7.05-.85s3.21.02 3.29-.66c.07-.68-.32-2.49-.65-2.99-.34-.5-.67-.53-2.12-.52-1.45.02-5.51.2-5.51.2l-.14-3.25s5.55-.27 5.97-.39.74-.87.42-2.13-.56-1.71-1.52-1.76c-.95-.05-5-.1-5-.1l-.16-3.84zm14.84 15.65-.34-11.75L57.16 29c1.24 2.92 1.89 3.25 2.12 3.34s3.85 0 4.98-.5 1.06-1.1 1.06-1.1l.16-18.29s-.12-1.19-2.68-1.28-2.58-.2-2.58 1.1.44 14.51.44 14.51L55.31 11.7c-.21-.27-1.08-.32-2.52-.21-1.45.11-3.5.18-3.75 1.25-.25 1.06-.28 17.4-.25 17.9.04.5.23 1.22 2.05 1.45 1.82.22 3.18.3 3.18-.32zm24.67-20.54c-8.33-1.12-14.99 9.43-11.05 16.23 1.73 2.99 8.19 6.96 15.43 3.05 7.25-3.92 3.64-18.37-4.38-19.28zm-5.21 8.04c-.85 3.37-.44 6.93 1.34 8.34 1.79 1.4 4.01 1.24 5.36-2.31.85-2.26.18-10.39-2.79-10.35-1.69.01-3.51 2.71-3.91 4.32z",
    fill: "#99d436"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.88 28.03.35-15.27c-.12-.11-1.27-.8-1.36 2.61s.48 11.8.55 12.51c.07.72.46.42.46.15zm4.87-7.06 5.71-8.69c0-.18-.28-.16-.44-.06-.16.11-6.57 7.74-6.62 7.84-.06.12 1.25 1.2 1.35.91zm10.03-8.39s-.04 1.06.37 1.15 5.94-1.21 8.39-1.4l4.35-.14c.18-.06-.2-.55-.55-.52l-8.43.33c-3.57.26-4.19.33-4.13.58zm2.17 16.87.39-13.12-1.48-.02.28 9.76c.26 3.68.43 3.77.81 3.38zm13.71-4.44-.07-12.25c.09-.54.39-.82 2.21-.87 1.82-.06 2.77-.02 2.66.3-.1.32-3.55.8-3.69 1.17s-.69 11.29-.85 11.63-.26.02-.26.02zm12.07 1.6-.78-15.06c.13-.44 1.29-.11 1.31.14s-.14 14.1-.14 14.63c0 .54-.39.29-.39.29zM76.55 11.8s-3.08.21-4.93 1.96c-1.86 1.74-1.38 2.88-1.13 3.18s1.34.46 1.84-.55c.49-1.01 1.29-2.54 2.37-3.36s1.59-.75 1.8-.87c.21-.13.05-.36.05-.36zm3.44 4.25s2.07 3.5 1.31 7.47c-.76 3.96-3.64 5.95-3.64 6.17 0 .21 1.75.44 2.3.04.54-.41 2.05-2.54 2.49-5.19s-.16-5.47-.76-6.81-1.85-2.52-1.7-1.68z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.03 24.9s1.87-3.36 2.6-3.4 1.5.05 2.93.57 1.68 1.37 1.36 2.26S93 29.4 93 29.4l1.69 6.72c.14.85-.49 1.83-2.52 1.67s-3.2-1.23-3.69-2.21-.73-2.38-.73-2.38-1.57 2.49-2.49 2.95-2.79.32-3.43.14-1.64-.98-1.8-1.94 3.87-5.21 3.97-5.56c.11-.35-2.01-5.69-1.84-6.7.18-1.02 1.27-1.69 2.86-1.58s1.96.16 2.56 1.35l1.45 3.04z",
    style: {
      fill: "#262424"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.69 27.54s2.76-4.62 3.25-4.84c.5-.21 1.57.05 2.48.35.9.3.74.58.28 1.39l-2.95 5.21 1.82 5.74c.18.89.12 1.39-.64 1.37s-2.97.37-3.58-1.58c-.62-1.96-1.12-4.69-1.12-4.69l-3.62 4.8c-.49.34-2.19.25-2.86-.14-.67-.4-.85-.82-.62-1.16s3.99-5.17 3.99-5.17l-1.85-6.08c-.23-1.12.53-1.25 1.19-1.25.65 0 2.08-.43 2.65 1.39l1.58 4.66z",
    fill: "#fbc34f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.91 26.91s-1.15-3.52-1.17-4.3.99-.71 1.66-.59.74.48.58.48-1.36-.1-1.41.09c-.06.2.33 3.49.51 4.12.18.64-.17.2-.17.2zm-1.96 5.67s-1.15 1.46-1.17 1.67.42.55.55.39c.12-.16.92-1.9.9-2.03-.02-.12-.28-.03-.28-.03zm6.89-6.2s1.94-3.16 2.26-3.22c.32-.05 1.82.06 1.73.3-.09.25-1.13.06-1.31.2s-2.07 2.43-2.33 2.7-.46.2-.35.02z",
    style: {
      fill: "#fff"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 13.136,
    y1: 3.143,
    x2: 13.624,
    y2: 17.066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e61627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#930a12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#2a1a1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#930a12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61627"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.01 2.19c2.95 0 5.51 3.4 5.71 7.59s-2.04 7.59-4.99 7.59-5.51-3.4-5.71-7.59 2.04-7.59 4.99-7.59z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 9.146,
    y1: 11.419,
    x2: 19.289,
    y2: 7.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#930a12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#e61627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#930a12"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.72 2.27c2.96 0 5.46 3.36 5.58 7.51.13 4.15-2.17 7.51-5.12 7.51S8.72 13.93 8.6 9.78c-.14-4.15 2.16-7.51 5.12-7.51z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.64 4.94c1.92 0 3.6 2.15 3.75 4.8.16 2.65-1.27 4.79-3.19 4.79s-3.6-2.14-3.76-4.79c-.15-2.65 1.28-4.8 3.2-4.8z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 6.92c1 0 1.9 1.2 2.02 2.68s-.59 2.68-1.58 2.68-1.9-1.2-2.02-2.68c-.13-1.48.58-2.68 1.58-2.68z",
    fill: "#e61627"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 8.39c.53 0 1.02.56 1.08 1.26.06.69-.32 1.26-.85 1.26s-1.01-.56-1.08-1.26c-.06-.7.32-1.26.85-1.26z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38 8.81c.36 0 .68.37.73.84.04.46-.21.84-.57.84s-.68-.38-.73-.84c-.04-.47.21-.84.57-.84zm63.59 19.36 18.64-1.86a1.14 1.14 0 0 1 1.24 1.02l.19 1.89a1.14 1.14 0 0 1-1.01 1.24l-18.64 1.87c-.62.06-1.17-.4-1.24-1.02l-.18-1.89c-.07-.63.38-1.19 1-1.25z",
    style: {
      fill: "#262424"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 78.833 31.637)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "M"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 81.527 31.311)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "U"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 83.9 31.122)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 85.632 30.926)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "T"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 87.68 30.666)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "I"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 88.58 30.604)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "P"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 90.758 30.345)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 92.747 30.152)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "I"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 93.645 30.088)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9885 -.1045 .1039 .9946 95.823 29.827)",
    style: {
      fontSize: "3.418px",
      fontFamily: "Arial-BoldMT",
      fill: "#fff"
    }
  }, "R"), /*#__PURE__*/React.createElement("path", {
    d: "m2.42 12.45-.1-.77.35-.04c.45-.06.54.71.1.77l-.35.04zm.37-2.68c.77-.1 1.03 1.1.49 1.49.75.16.81 1.49-.03 1.6l-1.91.24-.03-.24.34-.04-.33-2.63-.35.04L.96 10l1.83-.23zm-.54 1.36.3-.04c.42-.05.33-.82-.1-.77l-.3.04.1.77zm4.23.43-.25-1.99.15-.02-.03-.24-1.1.14.03.24.15-.02.28 2.24c.04.33-.5.4-.54.07l-.28-2.24.15-.02-.03-.24-1.09.14.03.24.15-.02.25 1.99c.16 1.27 2.29 1 2.13-.27zm2.75.54-.19-1.5-.84.1.16 1.26-.47.06-.33-2.62.15-.02-.03-.23-1.1.14.03.24.16-.03.33 2.63-.22.03.03.24 2.32-.3zm2.52-.32-.19-1.5-.84.11.16 1.26-.47.06-.33-2.63.14-.02-.02-.24-1.1.14.03.24.16-.02.33 2.63-.22.03.03.23 2.32-.29zm5.1-3.56.19-.03.33 2.64-.19.02.03.23 2.23-.28v-.07l-.14-1.08-.82.11.11.91-.43.06L18 9.45l.73-.1-.06-.47-.73.09-.11-.87.43-.06.08.61.82-.11-.07-.6-.02-.11-.02-.13-2.23.28zm5.19-.66.19-.02.33 2.63-.19.02.03.24 2.23-.29-.01-.07-.13-1.08-.82.11.11.91-.43.05-.16-1.27.72-.1-.06-.47-.72.09-.11-.87.43-.06.08.61.82-.11-.07-.61-.02-.09-.02-.14-2.23.28zm-.79 2.77-.12-.96.45-1.75.2-.03-.03-.23-1.05.13.03.24.06-.01-.19.73-.38-.66.28-.04-.03-.23-1.25.16.03.24.19-.03.9 1.58.12.96-.25.03.03.24 1.25-.16-.03-.23zM13.9 9.21l-.77.1-.05-.23c-.08-.38-.63-.31-.58.07.02.17.06.39.25.44.3.08.91.14 1.11.35.31.33.4 1.54-.63 1.77-.56.12-1.22-.12-1.31-.83l-.02-.17.78-.1.04.33c.05.39.61.31.58-.07-.11-1.39-1.39-.07-1.57-1.46-.14-1.29 1.98-1.68 2.17-.2z",
    style: {
      fillRule: "evenodd",
      fill: "#262424"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9939 0 0 1 85.306 13.779)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: 1.806,
    x: 0,
    y: 0,
    style: {
      fill: "#262424",
      fontFamily: "Arial-BoldMT"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.16,
    fontSize: 1.806,
    y: 0,
    style: {
      fill: "#262424",
      fontFamily: "Arial-BoldMT"
    }
  }, "M")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaKentuckyKeno);
export default __webpack_public_path__ + "static/media/usa_kentucky_keno.d163e97f5c25f7cc4eef9859720f220b.svg";
export { ForwardRef as ReactComponent };